import { createReducer } from '@reduxjs/toolkit';
import { initialState } from '@modules/documents/store';
import { getClearTrashModeRoutine } from '../actions';
import { TClearTrashMode } from '@modules/documents/types/document-state';

export const getClearTrashMode = createReducer(initialState, {
  [getClearTrashModeRoutine.REQUEST]: (state) => {
    state.isFetching = true;
    return state;
  },
  [getClearTrashModeRoutine.SUCCESS]: (
    state,
    action: {
      payload: {
        clearTrashMode: TClearTrashMode;
      };
    }
  ) => {
    state.clearTrashMode = action.payload.clearTrashMode;
    return state;
  },
  [getClearTrashModeRoutine.FULFILL]: (state) => {
    state.isFetching = false;
    return state;
  }
});
